module.exports = __webpack_public_path__ + "img/Typing-rafiki.608d47cc.svg";